import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'student.studentSimulated.title',
    defaultMessage: 'Simulated',
  },
  answer: {
    id: 'student.studentSimulated.answer',
    defaultMessage: 'Answer',
  },
  yourAnswer: {
    id: 'student.studentSimulated.yourAnswer',
    defaultMessage: 'Your answer',
  },
  viewReport: {
    id: 'student.studentSimulated.viewReport',
    defaultMessage: 'View report',
  },
  date: {
    id: 'student.studentSimulated.date',
    defaultMessage: 'Date',
  },
  studentGrade: {
    id: 'student.studentSimulated.report.studentGrade',
    defaultMessage: 'Student hits',
  },
  studentGroupAverage: {
    id: 'student.studentSimulated.report.studentGroupAverage',
    defaultMessage: 'Class Average',
  },
  schoolAverage: {
    id: 'student.studentSimulated.report.schoolAverage',
    defaultMessage: 'School average',
  },
  overallAveragePerformance: {
    id: 'student.studentSimulated.report.overallAveragePerformance',
    defaultMessage: 'Overall average performance',
  },
  back: {
    id: 'student.studentSimulated.report.back',
    defaultMessage: 'Back',
  },
  school: {
    id: 'student.studentSimulated.report.school',
    defaultMessage: 'School',
  },
  class: {
    id: 'student.studentSimulated.report.class',
    defaultMessage: 'Class',
  },
  student: {
    id: 'student.studentSimulated.report.student',
    defaultMessage: 'Student',
  },
  loadingMessage: {
    id: 'student.studentSimulated.report.loadingMessage',
    defaultMessage:
      'The report card are being generated and, depending on the number of students, this process may take a few minutes to complete, please wait ...',
  },
  filenameStudentPdf: {
    id: 'student.studentSimulated.report.filenameStudentPdf',
    defaultMessage: 'student',
  },
  filenameBatchStudentPdf: {
    id: 'student.studentSimulated.report.filenameBatchStudentPdf',
    defaultMessage: 'batch',
  },
  titleStudent: {
    id: 'student.studentSimulated.report.titleStudent',
    defaultMessage: 'Report',
  },
  batchPdf: {
    id: 'student.studentSimulated.report.batchPdf',
    defaultMessage: 'Generate batch',
  },
  studentPerformanceByQuestion: {
    id: 'student.studentSimulated.report.studentPerformanceByQuestion',
    defaultMessage: 'Student performance by question',
  },
  correct: {
    id: 'student.studentSimulated.report.correct',
    defaultMessage: 'Correct',
  },
  loadReportsCard: {
    id: 'student.studentSimulated.report.loadReportsCard',
    defaultMessage: 'To load the reports, you must select the Course and Student.',
  },
  filters: {
    id: 'student.studentSimulated.report.filters',
    defaultMessage: 'Filters',
  },
  clear: {
    id: 'student.studentSimulated.report.clear',
    defaultMessage: 'Clear',
  },
  performanceComparison: {
    id: 'student.studentSimulated.report.performanceComparison',
    defaultMessage: 'Comparison of performance by school classes x student',
  },
  studentPerformanceByComponent: {
    id: 'student.studentSimulated.report.studentPerformanceByComponent',
    defaultMessage: 'Student performance by curriculum component',
  },
  questionDetail: {
    id: 'student.studentSimulated.report.questionDetail',
    defaultMessage: 'Question Detail',
  },
  question: {
    id: 'student.studentSimulated.report.question',
    defaultMessage: 'Question',
  },
  accessEssayCorrections: {
    id: 'reports.application.details.accessEssayCorrections',
    defaultMessage: 'Access essay corrections',
  },
});
